const getExperienceSelected = function (state) {
  return state.experience.selected
}

const getListExperience = function (state) {
  return state.experience.list
}

const getExperienceFilter = function (state) {
  return {...state.experience.filter}
}

const getExperienceOrder = function (state) {
  return {...state.experience.order}
}

export default {
  getExperienceSelected,
  getExperienceFilter,
  getExperienceOrder,
  getListExperience
}



// WEBPACK FOOTER //
// ./src/front/store/modules/itinerario/getters/experience.js